import React from 'react';
import Head from 'next/head';
import ActiveLink from './ActiveLink';

class Wrapper extends React.Component
{
    render()
    {
        const {children} = this.props;
        return <div>
            <Head>
                <title>Weishi solutions Limited Company</title>
                <meta content="text/html; charset=utf-8" />
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <link href='https://fonts.googleapis.com/css?family=Raleway:400,100,200,300,500,600,700,800,900' rel='stylesheet' type='text/css'/>
                <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js"></script>
                <script src="/static/js/skel.min.js"></script>
                <script src="/static/js/skel-panels.min.js"></script>
                <script src="/static/js/init.js"></script>
                <link rel="stylesheet" href="/static/css/main.css" />
                <noscript>
                    <link rel="stylesheet" href="/static/css/skel-noscript.css" />
                    <link rel="stylesheet" href="/static/css/style.css" />
                    <link rel="stylesheet" href="/static/css/style-desktop.css" />
                </noscript>

            </Head>
            <div id="header-wrapper">
                <div id="header">
                    <div className="container">
                        <div id="logo">
                            <h1><a href="/">Weishi Solutions</a></h1>
                        </div>
                        <nav id="nav">



                            <ul>
                                <li>
                                    <ActiveLink href="/">
                                        Homepage
                                    </ActiveLink>
                                </li>
                                <li>
                                    <ActiveLink href="/contact">
                                        Contact us
                                    </ActiveLink>

                                </li>
                                {/*<li>*/}
                                    {/*<ActiveLink href="/about">*/}
                                        {/*About*/}
                                    {/*</ActiveLink>*/}
                                {/*</li>*/}

                                {/*<Link href="/about">Services</Link>*/}
                                {/*<Link href="/refs">References</Link>*/}
                                {/*<Link href="/blog">Blog</Link>*/}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            {children}


            {/*<div id="footer">*/}
                {/*<div className="container">*/}
                    {/*<div className="row">*/}
                        {/*/!*<section className="4u">*!/*/}
                            {/*/!*<header>*!/*/}
                                {/*/!*<h2>Nulla eleifend</h2>*!/*/}
                            {/*/!*</header>*!/*/}
                            {/*/!*<ul className="default">*!/*/}
                                {/*/!*<li><a href="#">Pellentesque quis elit non gravida blandit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Lorem ipsum dolor sit consectetuer adipiscing elit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Phasellus nec erat sit nibh pellentesque congue.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Cras vitae metus aliquam pellentesque pharetra.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Duis non ante in metus commodo euismod lobortis.</a></li>*!/*/}
                            {/*/!*</ul>*!/*/}
                        {/*/!*</section>*!/*/}
                        {/*/!*<section className="4u">*!/*/}
                            {/*/!*<header>*!/*/}
                                {/*/!*<h2>Etiam posuere</h2>*!/*/}
                            {/*/!*</header>*!/*/}
                            {/*/!*<ul className="default">*!/*/}
                                {/*/!*<li><a href="#">Pellentesque quis elit non gravida blandit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Lorem ipsum dolor sit consectetuer adipiscing elit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Phasellus nec erat sit nibh pellentesque congue.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Cras vitae metus aliquam pellentesque pharetra.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Duis non ante in metus commodo euismod lobortis.</a></li>*!/*/}
                            {/*/!*</ul>*!/*/}
                        {/*/!*</section>*!/*/}
                        {/*/!*<section className="4u">*!/*/}
                            {/*/!*<header>*!/*/}
                                {/*/!*<h2>Mauris vulputate</h2>*!/*/}
                            {/*/!*</header>*!/*/}
                            {/*/!*<ul className="default">*!/*/}
                                {/*/!*<li><a href="#">Pellentesque quis elit non gravida blandit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Lorem ipsum dolor sit consectetuer adipiscing elit.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Phasellus nec erat sit nibh pellentesque congue.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Cras vitae metus aliquam pellentesque pharetra.</a></li>*!/*/}
                                {/*/!*<li><a href="#">Duis non ante in metus commodo euismod lobortis.</a></li>*!/*/}
                            {/*/!*</ul>*!/*/}
                        {/*/!*</section>*!/*/}
                    {/*</div>*/}
                {/*</div>*/}
            {/*</div>*/}




            {/*<header>*/}
                {/*<Nav/>*/}
            {/*</header>*/}

            {/*<main>*/}
                {/*{children}*/}
            {/*</main>*/}

            <div id="copyright">
                <div className="container">
                    <p>25TH FLOOR, WORKINGTON TOWER,</p>
                    <p>78 BONHAM STRAND, SHEUNG WAN</p>
                    <p>HONG KONG</p>
                </div>
                <p style={{fontSize:"7px",float:"right"}}>
                    Design: <a href="http://templated.co">TEMPLATED</a> Images: <a
                href="http://unsplash.com">Unsplash</a> (<a href="http://unsplash.com/cc0">CC0</a>)
                </p>

            </div>
            {/*<footer>*/}
                {/**/}
            {/*</footer>*/}
        </div>
    }
}

export default Wrapper;